module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAA6klEQVRIS+3VO0oEQRQF0PP8geASDEyMzGYLrsBZgaIgGAkGRhoZ+wkNBt2AkdGswkRMBEFwCyIG+qSlHURUumg7UKy432nq1qUqdLSiI9cIzsxxjLX80XNEPFXGK5yZqzhGhbdZFboeEYM3+ATLbcR3s6cRsfK34CEmsPhFRHc4xxomS6LoRcRFZi5hH3P18CMOsBcR95l5iYUS+AYbETHMzGlso4etiLjOzFkcof9hR40P76zGbutqTmETO5j5JKbGcDX7gENcYRfz31SzCC6p+D88SuuXR9HNtVkX/+cv+pKSNv22szfvBZf7fxc8bZGcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_email.png
// module id = LNbV
// module chunks = 1